import styled from '@emotion/styled';

import { CloseButton } from '../../../../../../components/Button/components/CloseButton';
import { Wrapper } from '../Content/Content.styles';

export const Container = styled(Wrapper)`
  width: 100%;
  max-width: 620px;
  height: auto;
  padding: initial;
  border-radius: 0;
  background-color: var(--color-white);
  z-index: 1210;

  @media (max-width: 600px) {
    height: 100% !important;
  }
  @media (min-width: 600px) {
    width: 600px;
    border-radius: var(--border-radius-m);
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-24) var(--spacing-16);

  @media (min-width: 600px) {
    padding: var(--spacing-24);
  }
`;

export const Title = styled.span`
  font: var(--font-heading-5);
  color: var(--color-black);
  margin-right: var(--spacing-16);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledCloseButton = styled(CloseButton)`
  margin-left: auto;
`;

export const Body = styled.div`
  flex: 1;

  @media (min-width: 600px) {
    margin-top: var(--spacing-12);
  }
`;
